import { parsePayloadForQuery } from '@/helpers/utils.js';
import axios from 'axios';
import Vue from 'vue';

export const MODAL_NAME = {
  CREATE: 'create',
  EDIT_DETAILS: 'editDetails',
  SECURITY_DETAILS: 'securityDetails',
  GRANT_ROLE: 'grantRole'
}

const state = {
  items: [],
  modals: {
    create: false,
    editDetails: false,
    securityDetails: false,
    grantRole: false
  },
  item: null
};

const getters = {
  getUser: state => state.item,
  getUsers: state => state.items,
  isCreateOpen: state => state.modals.create,
  isEditDetailsOpen: state => state.modals.editDetails,
  isSecurityDetailsOpen: state => state.modals.securityDetails,
  isGrantRoleOpen: state => state.modals.grantRole
};

const mutations = {
  itemsLoaded(state, payload) {
    state.items = payload;
  },
  itemLoaded(state, payload) {
    state.item = payload;
  },
  open(state, modalName) {
    Vue.set(state.modals, modalName, true);
  },
  close(state, modalName) {
    Vue.set(state.modals, modalName, false);
  },
};

const actions = {
  get(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/users${queryParams}`);
  },
  search(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/users/search${queryParams}`);
  },
  getRoles(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/users/roles${queryParams}`);
  },
  getCompanies(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/users/companies${queryParams}`);
  },
  create(state, payload) {
    return axios.post(`/users`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Create user - ERROR - ', data.failures[0].error);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  edit(state, payload) {
    return axios.patch(`/users`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit user - ERROR - ', data.failures[0].error);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  updateRole(state, payload) {
    return axios.post(`/users/update-roles`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit Role Assignment - ERROR - ', data.failures);
          throw data.failures;
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  delete(state, payload) {
    return axios.delete(`/users?ids=${payload}`)
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};